import { Info } from "lucide-react";
import type { ReactNode } from "react";

export function TabNote({ children }: { children: ReactNode }) {
	return (
		<p className="flex items-start gap-2 rounded-md border bg-muted/40 px-3 py-2 text-sm text-muted-foreground">
			<Info className="mt-0.5 size-4 shrink-0" />
			<span>{children}</span>
		</p>
	);
}
